var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resourceCreatePermission)?_c('div',{attrs:{"id":"page-user"}},[_c('vx-card',[_c('resource-create-tab-account',{staticClass:"mt-4"})],1)],1):_c('not-permission')
}
var staticRenderFns = []

export { render, staticRenderFns }